import React from 'react';
import { EmptyState } from '../../../components/ui';

// Phase 2 placeholder; the tab only exists when Fleet/Config says fleetRemote.
// eslint-disable-next-line no-unused-vars
const DeviceRemoteTab = ({ device, onDeviceChange }) => (
  <EmptyState
    variant="dashed"
    title="Remote view arrives in phase 2"
    description="Live screen and touch are designed in part 2 of the spec."
  />
);

export default DeviceRemoteTab;
